// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"8ae4f157d0babb773c32","453":"3518c36e23623a816fd3","522":"9357ab413e7edd4cfc1f"}[chunkId] + ".js";
};